<template>
    <div>
        <div class="input-group">
          <input class="form-control m-2 w-75" type="text" placeholder="Bestellnummer suchen..." v-model="searchorder">
          <button type="button" class="btn bg-transparent" @click="searchorder = ''" style="margin-left: -40px; z-index: 100;">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="ticket-search-info" v-if="searchorder != '' && filteredListOrder.length > 0">
            <span>
                Suchergebnisse für Bestellung {{ searchorder }}
                <a :href="backend + '/api/orders/' + eventId + '/' + searchorder + '/print'"> – Bestellung herunterladen</a>
                <a href="javascript:;" class="send-link" @click="openSendModal"> – Per E-Mail senden</a>
            </span>
            <div v-if="orderLastSend" class="order-last-send">
                Zuletzt an {{ orderLastSend.email }} am {{ formatDateTime(orderLastSend.sentat) }}
            </div>
        </div>
        <div class="ticket-search-info" v-else-if="searchorder != ''">
            <span>Keine Tickets für Bestellung {{ searchorder }}</span>
        </div>

        <ul class="ticket-list">
            <li class="ticket-list-item" v-for="ticket in filteredListOrder" :key="ticket.id">
                <div class="d-flex justify-content-between">
                    <div class="flex-item">
                        <b>Bestellung {{ ticket.order}}</b>
                        <span> – Ticket {{ ticket.code }}</span>
                        <div class="ticket-meta">
                            <span>Erstellt: {{ formatDateTime(ticket.createdat) }}</span>
                            <span class="meta-sep">·</span>
                            <span
                                v-if="ticket.emailsendcount > 0"
                                class="send-status sent"
                                @click="ticket.emailsendcount > 1 ? toggleHistory(ticket.id) : null"
                                :class="{ clickable: ticket.emailsendcount > 1 }"
                                :title="ticket.emailsendcount > 1 ? 'Versandhistorie anzeigen' : ''"
                            >
                                <i class="fas fa-envelope"></i>
                                Gesendet {{ formatDateTime(ticket.lastemailsentat) }} an {{ ticket.lastemailsentto }}
                                <span v-if="ticket.emailsendcount > 1"> ({{ ticket.emailsendcount }}×)</span>
                            </span>
                            <span v-else class="send-status never">Noch nicht per E-Mail gesendet</span>
                        </div>
                        <ul v-if="historyOpenId === ticket.id && ticket.emailsends && ticket.emailsends.length" class="send-history">
                            <li v-for="(s, idx) in ticket.emailsends" :key="idx">
                                {{ formatDateTime(s.sentat) }} – {{ s.email }}
                            </li>
                        </ul>
                    </div>
                    <div class="flex-item">
                        <a :href="backend + '/api/tickets/' + ticket.id + '/print'"><i class="fas fa-download ticket-button"></i></a>
                        <a href="javascript:;" v-on:click="deleteTicket(ticket.id)"><i class="fas fa-trash-alt ticket-button"></i></a>
                    </div>
                </div>
            </li>
        </ul>
        <div class="d-flex justify-content-center" v-if="!tickets.length">Keine Tickets gefunden</div>

        <!-- Send order modal -->
        <div class="modal-mask" v-if="showSendModal">
            <div class="modal-wrapper">
                <div class="send-modal-container">
                    <h4>Bestellung {{ searchorder }} per E-Mail senden</h4>
                    <p class="text-muted small mb-2">{{ filteredListOrder.length }} Ticket(s) als Anhang</p>
                    <div v-if="sendError" class="alert alert-danger" role="alert">{{ sendError }}</div>
                    <div v-if="sendInfo" class="alert alert-success" role="alert">{{ sendInfo }}</div>
                    <label for="send-email">E-Mail-Adresse</label>
                    <input id="send-email" class="form-control mb-3" type="email" v-model="sendEmail" :disabled="sendBusy" @keyup.enter="sendOrderEmail"/>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-outline-secondary mr-2" @click="closeSendModal" :disabled="sendBusy">Abbrechen</button>
                        <button class="btn btn-primary" @click="sendOrderEmail" :disabled="!sendEmailValid || sendBusy">
                            {{ sendBusy ? 'Sende…' : 'Senden' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default ({
    name: 'TicketList',
    data() {
        return {
            backend: process.env.VUE_APP_BACKEND,
            searchorder: '',
            historyOpenId: null,
            showSendModal: false,
            sendEmail: '',
            sendError: '',
            sendInfo: '',
            sendBusy: false,
        }
    },
    props: {
        tickets: {
            type: Array,
            required: true
        },
        event: {
            type: Object,
            default: null,
        },
    },
    methods: {
        formatDateTime(value) {
            if (!value) return '—';
            const d = new Date(value);
            if (isNaN(d.getTime()) || d.getFullYear() < 2000) return '—';
            return d.toLocaleString('de-DE', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit',
            });
        },
        toggleHistory(id) {
            this.historyOpenId = this.historyOpenId === id ? null : id;
        },
        openSendModal() {
            this.sendError = '';
            this.sendInfo = '';
            this.sendEmail = (this.orderLastSend && this.orderLastSend.email) ? this.orderLastSend.email : '';
            this.showSendModal = true;
        },
        closeSendModal() {
            this.showSendModal = false;
            this.sendBusy = false;
        },
        sendOrderEmail() {
            if (!this.sendEmailValid) return;
            this.sendBusy = true;
            this.sendError = '';
            this.sendInfo = '';
            axios.post(
                process.env.VUE_APP_BACKEND + '/api/orders/' + this.eventId + '/' + this.searchorder + '/send',
                { email: this.sendEmail.trim() },
                { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
            ).then(() => {
                this.sendInfo = 'E-Mail erfolgreich gesendet';
                this.$emit('TicketDeleted'); // reload list (same as refresh)
                setTimeout(() => { this.closeSendModal(); }, 800);
            }).catch((e) => {
                this.sendError = (e.response && e.response.data && e.response.data.message)
                    ? e.response.data.message
                    : 'Versand fehlgeschlagen';
            }).finally(() => {
                this.sendBusy = false;
            });
        },
        deleteTicket(id) {
            if(confirm("Ticket wirklich löschen?")){
                axios.delete(process.env.VUE_APP_BACKEND + '/api/tickets/' + id, { withCredentials: true })
                .then(() => { this.$emit('TicketDeleted')  })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        this.$emit('logout');
                    } else {
                        console.log(error);
                    }
                });
            }
        }
    },
    computed: {
        eventId() {
            if (this.event && this.event.id) return this.event.id;
            if (this.tickets.length) return this.tickets[0].eventid;
            return null;
        },
        filteredListOrder () {
            return this.tickets.filter(ticket => ticket.order == this.searchorder || this.searchorder == '')
        },
        orderLastSend() {
            if (!this.searchorder || !this.filteredListOrder.length) return null;
            let best = null;
            for (const t of this.filteredListOrder) {
                if (!t.lastemailsentat) continue;
                const at = new Date(t.lastemailsentat).getTime();
                if (!best || at > best.at) {
                    best = { at, email: t.lastemailsentto, sentat: t.lastemailsentat };
                }
            }
            return best;
        },
        sendEmailValid() {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.sendEmail || '').trim());
        }
    }
})
</script>

<style language="scss" scoped>
.ticket-list {
    list-style-type: none;
    padding: 5px;
}
.ticket-list-item {
    padding: 1em;
    border-bottom: 1px solid #0000002b;
}
.ticket-list-item i {
    font-size: 1.5em;
}

.ticket-button {
    padding-right: 1em;
    color: grey;
}

.ticket-button:hover {
    color: darkgray;
}

.ticket-meta {
    margin-top: 0.35em;
    font-size: 0.8em;
    color: #666;
}
.meta-sep {
    margin: 0 0.35em;
}
.send-status.never {
    color: #999;
}
.send-status.sent {
    color: #444;
}
.send-status.sent .fa-envelope {
    font-size: 0.95em;
    margin-right: 0.25em;
    color: #5a7a5a;
}
.send-status.clickable {
    cursor: pointer;
    text-decoration: underline dotted;
}
.send-history {
    list-style: none;
    padding: 0.4em 0 0 0;
    margin: 0;
    font-size: 0.78em;
    color: #555;
}
.send-history li {
    padding: 0.15em 0;
}

.ticket-search-info {
    font-size: 12px;
    color: grey;
    margin: 8px;
    min-height: 1.2em;
}
.order-last-send {
    margin-top: 0.25em;
    font-size: 11px;
}
.send-link {
    margin-left: 0.15em;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  display: table;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.send-modal-container {
  width: 420px;
  max-width: 92vw;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.25);
}
</style>
